import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import AddIcon from '@material-ui/icons/Add';
import React, {useState} from 'react';
import {i18n2} from '../../../features/i18n/i18n';
import PopupRemove from 'components/forms/Remove';
import {ObjectSchema} from 'yup';
import FormEditor from 'components/Editors/FormEditor';
import {RemoteLookupProps, WithoutDeleteAndEditProps} from '../MasterGrid';
import {useActionButtonStyles} from 'components/grid-dx/styles/actionButtonStyles';
import {useIsTablet} from 'components/hooks/useIsTablet';

interface DeleteButtonProps {
  id: string | Array<string>;
  promise: Promise<any> | null;
  row: any;
  withoutDelete?: WithoutDeleteAndEditProps | null;
  refresh: any;
}

interface EditButtonProps {
  promise: Promise<any>;
  id: string | Array<string>;
  schema: ObjectSchema;
  row: any;
  columnOptions: any;
  initialValues: any;
  refresh: any;
  lookup: RemoteLookupProps[];
  withoutEdit?: WithoutDeleteAndEditProps | null;
}

export const AddButton = () => (
  <div style={{textAlign: 'center'}}>
    <IconButton size="small" title={i18n2._('Add')}>
      <AddIcon style={{color: '#4040a1'}} />
    </IconButton>
  </div>
);

export const EditButton = ({
  promise,
  id,
  schema,
  row,
  columnOptions,
  initialValues,
  refresh,
  lookup,
  withoutEdit,
}: EditButtonProps) => {
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen(true);
  };
  const styles = useActionButtonStyles();
  const isTablet = useIsTablet();

  if (withoutEdit != null) {
    if (withoutEdit.equals.includes(row[withoutEdit.column])) {
      return null;
    }
  }
  return !row.deleted ? (
    <>
      <IconButton
        size="small"
        title={i18n2._('Editar')}
        className={isTablet ? styles.tabletButton : styles.compactEdit}
        onClick={handleClick}>
        <EditIcon
          className={isTablet ? styles.tabletIcon : styles.compactEdit}
        />
      </IconButton>
      {open && (
        <FormEditor
          schema={schema}
          open={open}
          setOpen={setOpen}
          row={row}
          lookup={lookup}
          promise={promise}
          type={'edit'}
          columnOptions={columnOptions}
          initialValues={initialValues}
          refresh={refresh}
        />
      )}
    </>
  ) : null;
};

export const DeleteButton = ({
  id,
  promise,
  row,
  withoutDelete,
  refresh,
}: DeleteButtonProps) => {
  const [open, setOpen] = useState(false);
  const handleClick = () => {
    setOpen(true);
  };
  const styles = useActionButtonStyles();

  const isTablet = useIsTablet();

  if (withoutDelete != null) {
    if (row[withoutDelete.column] === withoutDelete.equals[0]) {
      return null;
    }
  }

  return !row.deleted ? (
    <>
      <IconButton
        size="small"
        title={i18n2._('Delete row')}
        className={isTablet ? styles.tabletButton : styles.compactDelete}
        onClick={handleClick}>
        <DeleteIcon
          className={isTablet ? styles.tabletIcon : styles.compactDelete}
        />
      </IconButton>
      {open && (
        <PopupRemove
          open={open}
          setOpen={setOpen}
          id={id}
          promise={promise}
          row={row}
          refresh={refresh}
        />
      )}
    </>
  ) : null;
};
